import type { Placement, Responsive } from "@slot/presentation";

/**
 * The bear character behind the grid (`BackdropLayer/CharacterOverlayLayer` in the Cocos scene, built at runtime from
 * `CharacterPrefab`). Positions are the layer's per-shape hosts from the scene dump, in composition-root units
 * (y-down), with the hosts' scales; the prefab scales the skeleton by 0.748 and the skeleton's origin is its feet.
 *
 * Desktop takes the default placeholder (`Pos 1`). Cocos moved the bear to `Pos 2` (570.657, 584.209) when `Pos 1` fell
 * outside the canvas, which only a desktop window far narrower than 16:9 does; not ported (plan, deferred list).
 */
export const CHARACTER_TUNING = {
  placement: {
    desktop: { x: 729.38, y: 507.765 },
    mobile: { x: 316.147, y: -451.385, scale: 0.7 },
    mobile_landscape: { x: 801.357, y: 522.709 },
  } as Responsive<Placement>,
  skeletonScale: 0.748,
  idleClip: "idle",
  reactionClip: "activate",
} as const;
